import Clipboard from '@react-native-clipboard/clipboard';
import analytics from 'extensions/analytics';

export function copyLink(link: string) {
  Clipboard.setString(link);
  analytics.log('Copied link');
}
